import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getCompleteSizes } from '@cian/adfox-component';
import * as React from 'react';
import { Base64 } from 'js-base64';
import { VideoTemplate } from '../templates/VideoTemplate';
import { TgbTemplate } from '../templates/TgbTemplate';
import { TgbStretchTemplate } from '../templates/TgbStretchTemplate';
import { TgbPrimaryTemplate } from '../templates/TgbPrimaryTemplate';
import { PictureTemplate } from '../templates/PictureTemplate';
import { PixelTemplate } from '../templates/PixelTemplate';
import { ParallaxGeneralTemplate } from '../templates/ParallaxGeneralTemplate';
import { useHTMLBannerInserts } from '../utils/useHTMLBannerInserts';
import { jsx as _jsx } from "react/jsx-runtime";
var KNOWN_BUNDLE_NAMES = ['banner.transfer'];
var KNOWN_TYPES = ['video', 'tgb', 'tgb_primary', 'tgb_stretch', 'picture', 'pixel', 'parallax_general'];
export var AdFoxTemplates = function AdFoxTemplates(props) {
  var containerId = props.containerId,
    bundleName = props.bundleName,
    bundleParams = props.bundleParams,
    eventEmitter = props.eventEmitter,
    deviceType = props.deviceType,
    height = props.height,
    width = props.width;
  useHTMLBannerInserts({
    eventEmitter: eventEmitter,
    containerId: containerId
  });
  if (bundleName && KNOWN_BUNDLE_NAMES.includes(bundleName) && bundleParams) {
    if (bundleName === 'banner.transfer' && bundleParams.htmlBase64) {
      try {
        var decodedParams = Base64.decode(bundleParams.htmlBase64);
        var parsedDecodedParams = JSON.parse(decodedParams);
        if (isParsedParamsValid(parsedDecodedParams)) {
          if (KNOWN_TYPES.includes(parsedDecodedParams.type)) {
            switch (parsedDecodedParams.type) {
              case 'parallax_general':
                return /*#__PURE__*/_jsx(ParallaxGeneralTemplate, {
                  deviceType: deviceType,
                  width: width,
                  height: height,
                  context: parsedDecodedParams
                });
              case 'video':
                return /*#__PURE__*/_jsx(VideoTemplate, _objectSpread({}, parsedDecodedParams));
              case 'tgb':
                return /*#__PURE__*/_jsx(TgbTemplate, _objectSpread({}, parsedDecodedParams));
              case 'tgb_stretch':
                return /*#__PURE__*/_jsx(TgbStretchTemplate, _objectSpread({}, parsedDecodedParams));
              case 'tgb_primary':
                return /*#__PURE__*/_jsx(TgbPrimaryTemplate, _objectSpread({}, parsedDecodedParams));
              case 'picture':
                return /*#__PURE__*/_jsx(PictureTemplate, _objectSpread({}, parsedDecodedParams));
              case 'pixel':
                return /*#__PURE__*/_jsx(PixelTemplate, {});
              default:
                // @ts-ignore
                console.warn('[AdFox] Known type is not found', parsedDecodedParams.type, bundleParams);
            }
          } else {
            console.warn('[AdFox] Unknown banner type', parsedDecodedParams.type, bundleParams);
          }
        } else {
          console.error('[AdFox] Invalid parsed params', bundleParams);
        }
      } catch (e) {
        console.error('[AdFox] Failed to decode/parse bundleParams', bundleParams, e);
      }
    } else {
      console.warn('[AdFox] Known bundle is invalid/not found', bundleName, bundleParams);
    }
  } else {
    console.warn('[AdFox] Unknown bundle', bundleName, bundleParams);
  }
  return /*#__PURE__*/_jsx("div", {
    id: containerId,
    style: getCompleteSizes({
      width: width,
      height: height
    })
  });
};
function isParsedParamsValid(params) {
  return 'type' in params;
}